import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Supabase auth lock steal / timeout — non-fatal after deferring onAuthStateChange work
if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    const r = event?.reason;
    const msg = r?.message ?? '';
    const isAuthLockNoise =
      msg.includes('lock:mashhad-app-auth') ||
      msg.includes('another request stole it') ||
      r?.isAcquireTimeout === true ||
      r?.name === 'NavigatorLockAcquireTimeoutError' ||
      (r?.name === 'AbortError' &&
        (msg.includes('abort') || (r?.stack && r.stack.includes('locks.js'))));
    if (isAuthLockNoise) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
